import React from "react";

const UserList = ({user,userClick}) => {
    return <div className="ye">
            {user && user.map((data, i) =>
                <div className="ye_item" key={`userData-${i}`} onClick={() => userClick(data)}>{data.value}/ <span className="global_bold global_pl_5">{data.label} {data.enDepartmentName? `(` +data.enDepartmentName +`)` : ""}</span></div>
            )}
        </div>
    /*onChange={onChangetextareaHandler}*/
}

export default React.memo(UserList);
